// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.mapping-wizard-page {
  max-width: 1440px;
  margin: 0 auto;
  padding: 1.5rem clamp(1rem, 2.5vw, 2rem) 2rem;
}

.page-header, .page-heading, .panel-heading, .step-footer, .table-footer,
.review-section-heading, .field-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.page-header {
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.page-heading {
  justify-content: flex-start;
  align-items: flex-start;
}

.heading-icon, .panel-heading-icon {
  display: grid;
  flex: 0 0 auto;
  width: 3rem;
  height: 3rem;
  place-items: center;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.35rem;
}

.eyebrow, .panel-kicker {
  margin: 0 0 0.25rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.page-header h1 {
  margin: 0;
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  font-weight: 750;
  letter-spacing: -0.035em;
}

.subtitle {
  max-width: 52rem;
  margin: 0.45rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.88rem;
  line-height: 1.55;
}

.cancel-top {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  border-radius: var(--ca-radius-md, 8px);
}

.page-alert {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.wizard-stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(0.35rem, 1.3vw, 1.2rem);
  margin: 0 auto 1.4rem;
  padding: 1.1rem 1.4rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: 0 3px 12px rgba(18, 35, 68, 0.035);
}

.step-item {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
  padding: 0.2rem;
  border: 0;
  background: transparent;
  color: var(--ca-text-muted, #8c96a8);
  cursor: default;
  text-align: left;
}

.step-item:disabled {
  opacity: 1;
}

.step-icon {
  display: grid;
  width: 2.35rem;
  height: 2.35rem;
  flex: 0 0 2.35rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 50%;
  background: var(--ca-bg-secondary, #eef2f8);
  font-size: 1rem;
  transition: all 0.18s ease;
}

.step-label {
  font-size: 0.82rem;
  font-weight: 650;
  white-space: nowrap;
}

.step-item.active {
  color: var(--ca-primary, #0e2e80);
}

.step-item.active .step-icon {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  box-shadow: 0 0 0 4px rgba(40, 80, 173, 0.1);
}

.step-item.completed {
  color: var(--ca-success, #198754);
  cursor: pointer;
}

.step-item.completed .step-icon {
  border-color: var(--ca-success, #198754);
  background: var(--ca-success, #198754);
  color: #fff;
}

.step-connector {
  width: clamp(1rem, 4vw, 4rem);
  height: 2px;
  flex: 0 1 4rem;
  background: var(--ca-border, #dfe4ec);
}

.step-connector.completed {
  background: var(--ca-success, #198754);
}

.wizard-card {
  overflow: hidden;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: 0 5px 20px rgba(18, 35, 68, 0.04);
}

.wizard-panel {
  padding: clamp(1rem, 2.5vw, 1.8rem);
}

.panel-heading {
  align-items: flex-start;
  margin-bottom: 1.4rem;
}

.panel-heading h2 {
  margin: 0.1rem 0 0.3rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.25rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.panel-heading p {
  max-width: 58rem;
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.85rem;
  line-height: 1.55;
}

.panel-heading-icon {
  width: 2.65rem;
  height: 2.65rem;
  font-size: 1.2rem;
}

.mapping-form {
  max-width: 850px;
}

.form-field {
  margin-bottom: 1.3rem;
}

.form-field label {
  display: block;
  margin-bottom: 0.45rem;
  color: var(--ca-text-primary, #172033);
  font-size: 0.85rem;
  font-weight: 700;
}

.required-mark {
  color: var(--ca-danger, #dc3545);
}

.form-control, .form-select {
  min-height: 2.7rem;
  border-color: var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  color: var(--ca-text-primary, #172033);
  font-size: 0.88rem;
}

.form-control:focus, .form-select:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.18rem rgba(40, 80, 173, 0.13);
}

.form-control[readonly] {
  background: var(--ca-bg-secondary, #eef2f8);
  color: var(--ca-text-secondary, #4b5870);
}

.description-control {
  min-height: 8rem;
  resize: vertical;
}

.field-hint {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.field-error {
  color: var(--ca-danger, #dc3545);
  font-size: 0.75rem;
}

.field-meta {
  min-height: 1.25rem;
  margin-top: 0.3rem;
}

.required-note {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.76rem;
}

.selection-count {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  flex: 0 0 auto;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(12rem, 1.5fr) minmax(11rem, 0.85fr) auto;
  gap: 0.7rem;
  margin-bottom: 1rem;
}

.search-field {
  display: flex;
  min-width: 0;
}

.search-field .form-control {
  min-width: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: grid;
  width: 2.7rem;
  flex: 0 0 2.7rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.clear-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  white-space: nowrap;
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.table-region app-main-table {
  display: block;
  min-width: 0;
}

.table-footer {
  align-items: center;
  margin-top: 0.9rem;
  padding-top: 0.8rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.76rem;
}

.selected-zone-strip {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin: 0 0 1rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.selected-zone-strip > i {
  color: var(--ca-primary, #0e2e80);
  font-size: 1.05rem;
}

.text-button {
  padding: 0.25rem 0.2rem;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.8rem;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.selected-zone-strip .text-button {
  margin-left: auto;
}

.state-panel, .empty-state {
  display: flex;
  min-height: 12rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  padding: 1.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.state-panel > i, .empty-state > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.8rem;
}

.state-panel h3, .empty-state h3 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1rem;
  font-weight: 700;
}

.state-panel p, .empty-state p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.84rem;
}

.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.loading-spinner {
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: mapping-spin 0.8s linear infinite;
}

.loading-spinner.small {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
}

.inline-loading {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 3rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
}

.inline-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
  padding: 0.7rem 0.8rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  font-size: 0.82rem;
}

.inline-error button {
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font-weight: 700;
  text-decoration: underline;
}

.review-panel {
  max-width: none;
}

.review-section {
  margin-top: 1.1rem;
  padding: 1.1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
}

.review-section-heading {
  margin-bottom: 0.8rem;
}

.review-section-heading h3 {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  font-size: 0.94rem;
  font-weight: 750;
}

.review-section-heading h3 > i {
  color: var(--ca-primary, #0e2e80);
}

.review-count {
  display: inline-grid;
  min-width: 1.45rem;
  height: 1.45rem;
  place-items: center;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.72rem;
}

.review-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem 1.5rem;
  margin: 0;
}

.review-details > div {
  min-width: 0;
}

.review-details dt {
  margin-bottom: 0.25rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.73rem;
  font-weight: 700;
}

.review-details dd {
  margin: 0;
  overflow-wrap: anywhere;
  color: var(--ca-text-primary, #172033);
  font-size: 0.87rem;
  white-space: pre-wrap;
}

.review-details .identifier {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.78rem;
}

.review-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.review-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  max-width: 100%;
  padding: 0.5rem 0.7rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
}

.review-chip i {
  color: var(--ca-primary, #0e2e80);
}

.review-chip span {
  overflow-wrap: anywhere;
}

.submit-alert {
  margin-top: 1rem;
}

.step-footer {
  margin-top: 1.6rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.step-footer .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.55rem;
  padding: 0.6rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.83rem;
  font-weight: 650;
}

.step-footer .btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
}

.step-footer .btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

.step-footer .btn-outline-secondary {
  border-color: var(--ca-border, #dfe4ec);
  color: var(--ca-text-secondary, #4b5870);
}

.finish-button {
  min-width: 10rem;
}

.button-spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: mapping-spin 0.7s linear infinite;
}

@keyframes mapping-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 850px) {
  .wizard-stepper {
    justify-content: space-between;
    gap: 0.25rem;
    padding-inline: 0.7rem;
  }
  .step-item {
    flex-direction: column;
    justify-content: center;
    gap: 0.35rem;
    flex: 1 1 0;
    text-align: center;
  }
  .step-label {
    font-size: 0.7rem;
    white-space: normal;
  }
  .step-connector {
    width: 0.7rem;
    flex: 0 0 0.7rem;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .clear-button {
    justify-self: start;
  }
  .review-details {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 520px) {
  .mapping-wizard-page {
    padding: 1rem 0.7rem 1.5rem;
  }
  .page-header {
    flex-direction: column;
  }
  .cancel-top {
    align-self: flex-end;
  }
  .heading-icon {
    width: 2.5rem;
    height: 2.5rem;
  }
  .panel-heading {
    gap: 0.6rem;
  }
  .panel-heading-icon {
    display: none;
  }
  .selection-count {
    padding: 0.4rem 0.5rem;
    font-size: 0.7rem;
  }
  .table-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .table-footer app-pagination {
    align-self: flex-end;
    max-width: 100%;
  }
  .step-footer {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .step-footer .btn {
    flex: 1 1 auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
/* Optional security-zone association choices */
.zone-choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.zone-choice-card {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  min-width: 0;
  padding: 1rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface, #fff);
  cursor: pointer;
  transition: border-color 0.18s ease, background-color 0.18s ease, box-shadow 0.18s ease;
}

.zone-choice-card.selected {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
  box-shadow: 0 0 0 2px rgba(40, 80, 173, 0.08);
}

.zone-choice-card input {
  flex: 0 0 auto;
  margin-top: 0.28rem;
  accent-color: var(--ca-primary, #0e2e80);
}

.zone-choice-icon {
  display: grid;
  flex: 0 0 2.25rem;
  width: 2.25rem;
  height: 2.25rem;
  place-items: center;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1rem;
}

.zone-choice-copy {
  display: grid;
  gap: 0.3rem;
  min-width: 0;
}

.zone-choice-copy strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.86rem;
}

.zone-choice-copy small {
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.77rem;
  line-height: 1.5;
}

.zone-selection-guidance {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin: 0.2rem 0 1.1rem;
  padding: 0.85rem 0.95rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-left: 3px solid var(--ca-primary-light, #2850ad);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
  line-height: 1.55;
}

.zone-selection-guidance > i {
  margin-top: 0.1rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 1rem;
}

.zone-selection-guidance strong {
  color: var(--ca-text-primary, #172033);
}

.selected-zones-panel {
  margin-top: 1.1rem;
  padding: 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-bg-secondary, #f8faff);
}

.selected-zones-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.7rem;
}

.selected-zones-heading h3 {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 750;
}

.selected-zones-heading > span {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.selected-zone-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 0.8rem;
  padding: 0.75rem 0;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.selected-zone-identity {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  min-width: 0;
}

.selected-zone-identity > i {
  margin-top: 0.1rem;
  color: var(--ca-primary, #0e2e80);
}

.selected-zone-identity > div {
  display: grid;
  gap: 0.2rem;
  min-width: 0;
}

.selected-zone-identity strong {
  overflow-wrap: anywhere;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.selected-zone-identity small {
  overflow-wrap: anywhere;
  color: var(--ca-text-muted, #8c96a8);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.68rem;
}

.zone-coverage-badge {
  padding: 0.3rem 0.55rem;
  border: 1px solid rgba(25, 135, 84, 0.18);
  border-radius: 999px;
  background: rgba(25, 135, 84, 0.08);
  color: var(--ca-success, #198754);
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
}

.zone-coverage-badge.partial {
  border-color: rgba(40, 80, 173, 0.18);
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.selected-zone-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.selected-zone-actions .btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.72rem;
}

.unzoned-assets-note {
  align-items: center;
}

.unzoned-assets-note .text-button {
  flex: 0 0 auto;
}

/* Review summary */
.review-subsection {
  margin-top: 0.9rem;
}

.review-subsection h4 {
  margin: 0 0 0.55rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
  font-weight: 750;
}

.review-chip small {
  padding-left: 0.25rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.67rem;
  font-weight: 700;
  white-space: nowrap;
}

.review-partial-zone {
  margin-top: 0.6rem;
  padding: 0.8rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-sm, 6px);
}

.review-partial-zone-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}

.review-partial-zone-heading strong {
  overflow-wrap: anywhere;
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
}

.review-partial-zone-heading span {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  white-space: nowrap;
}

.review-section-description {
  margin: -0.2rem 0 0.75rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.78rem;
  line-height: 1.5;
}

.review-empty-note {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.8rem;
}

/* Checkbox table popup for partial security-zone coverage */
.mapping-modal-backdrop {
  position: fixed;
  z-index: 1200;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(9, 18, 38, 0.56);
  backdrop-filter: blur(2px);
}

.mapping-modal {
  display: flex;
  flex-direction: column;
  width: min(100%, 1050px);
  max-height: min(92vh, 950px);
  overflow: hidden auto;
  padding: clamp(1rem, 2.4vw, 1.6rem);
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: 0 24px 80px rgba(9, 18, 38, 0.25);
}

.mapping-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.mapping-modal-header h2 {
  margin: 0.1rem 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.2rem;
  font-weight: 750;
}

.mapping-modal-header p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.82rem;
  line-height: 1.55;
}

.modal-close-button {
  display: grid;
  flex: 0 0 auto;
  width: 2.25rem;
  height: 2.25rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-surface, #fff);
  color: var(--ca-text-secondary, #4b5870);
}

.modal-close-button:hover {
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary, #0e2e80);
}

.modal-search-toolbar {
  margin-bottom: 0.75rem;
}

.modal-state {
  min-height: 8rem;
}

.modal-table-region {
  min-height: 5rem;
}

.modal-table-footer {
  margin-top: 0.6rem;
}

.mapping-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.65rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.mapping-modal-footer .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 2.55rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.82rem;
  font-weight: 650;
}

.mapping-modal-footer .btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
}

.mapping-modal-footer .btn-primary:hover {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

@media (max-width: 850px) {
  .zone-choice-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .selected-zone-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }
  .selected-zone-actions {
    grid-column: 1/-1;
    justify-content: flex-start;
  }
}
@media (max-width: 520px) {
  .mapping-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .mapping-modal {
    width: 100%;
    max-height: 94vh;
    padding: 1rem 0.8rem;
    border-radius: 14px 14px 0 0;
  }
  .mapping-modal-header h2 {
    font-size: 1.05rem;
  }
  .selected-zone-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .zone-coverage-badge {
    justify-self: start;
  }
  .selected-zone-actions {
    grid-column: auto;
  }
  .unzoned-assets-note {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .review-partial-zone-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.25rem;
  }
  .mapping-modal-footer {
    position: sticky;
    bottom: -1rem;
    margin-inline: -0.8rem;
    padding: 0.8rem;
    background: var(--ca-surface, #fff);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/data-protection/data-asset-mapping/data-asset-mapping-create-or-update/data-asset-mapping-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,sCAAA;EACA,0BAAA;AACJ;AAEE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EAEE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,cAAA;EACA,6CAAA;AAFF;;AAKA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAFF;;AAKA;EAAe,uBAAA;EAAyB,qBAAA;AAAxC;;AACA;EAAgB,2BAAA;EAA6B,uBAAA;AAI7C;;AAHA;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,kBAAA;AAMF;;AAJA;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAOF;;AALA;EAAkB,SAAA;EAAW,sCAAA;EAAwC,gBAAA;EAAkB,wBAAA;AAYvF;;AAXA;EAAY,gBAAA;EAAkB,mBAAA;EAAoB,wCAAA;EAA0C,kBAAA;EAAmB,iBAAA;AAmB/G;;AAlBA;EAAc,cAAA;EAAgB,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,uCAAA;AA0BtF;;AAzBA;EAAc,aAAA;EAAe,mBAAA;EAAqB,YAAA;AA+BlD;;AA7BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,8CAAA;AAgCF;;AA9BA;EAAa,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,YAAA;EAAc,eAAA;EAAgB,SAAA;EAAW,uBAAA;EAAyB,oCAAA;EAAsC,eAAA;EAAiB,gBAAA;AA2C9L;;AA1CA;EAAsB,UAAA;AA8CtB;;AA7CA;EAAa,aAAA;EAAe,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,mBAAA;EAAqB,2CAAA;EAA6C,kBAAA;EAAoB,2CAAA;EAA6C,eAAA;EAAiB,0BAAA;AA0DpO;;AAzDA;EAAc,kBAAA;EAAmB,gBAAA;EAAkB,mBAAA;AA+DnD;;AA9DA;EAAoB,iCAAA;AAkEpB;;AAjEA;EAA+B,wCAAA;EAA0C,sCAAA;EAAwC,WAAA;EAAa,4CAAA;AAwE9H;;AAvEA;EAAuB,iCAAA;EAAmC,eAAA;AA4E1D;;AA3EA;EAAkC,wCAAA;EAA0C,sCAAA;EAAwC,WAAA;AAiFpH;;AAhFA;EAAkB,6BAAA;EAA+B,WAAA;EAAa,cAAA;EAAgB,qCAAA;AAuF9E;;AAtFA;EAA4B,sCAAA;AA0F5B;;AAxFA;EAAe,gBAAA;EAAkB,iDAAA;EAAmD,wCAAA;EAA0C,mCAAA;EAAqC,6CAAA;AAgGnK;;AA/FA;EAAgB,mCAAA;AAmGhB;;AAlGA;EAAiB,uBAAA;EAAyB,qBAAA;AAuG1C;;AAtGA;EAAoB,uBAAA;EAAuB,sCAAA;EAAwC,kBAAA;EAAoB,gBAAA;EAAkB,uBAAA;AA8GzH;;AA7GA;EAAmB,gBAAA;EAAkB,SAAA;EAAW,wCAAA;EAA0C,kBAAA;EAAmB,iBAAA;AAqH7G;;AApHA;EAAsB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;AA0HvD;;AAxHA;EAAgB,gBAAA;AA4HhB;;AA3HA;EAAc,qBAAA;AA+Hd;;AA9HA;EAAoB,cAAA;EAAgB,sBAAA;EAAuB,sCAAA;EAAwC,kBAAA;EAAmB,gBAAA;AAsItH;;AArIA;EAAiB,gCAAA;AAyIjB;;AAxIA;EAA8B,kBAAA;EAAoB,6CAAA;EAA+C,uCAAA;EAAyC,sCAAA;EAAwC,kBAAA;AAgJlL;;AA/IA;EAA0C,4CAAA;EAA8C,iDAAA;AAoJxF;;AAnJA;EAA0B,2CAAA;EAA6C,wCAAA;AAwJvE;;AAvJA;EAAuB,gBAAA;EAAkB,gBAAA;AA4JzC;;AA3JA;EAAc,oCAAA;EAAsC,kBAAA;AAgKpD;;AA/JA;EAAe,gCAAA;EAAkC,kBAAA;AAoKjD;;AAnKA;EAAc,mBAAA;EAAqB,kBAAA;AAwKnC;;AAvKA;EAAiB,oCAAA;EAAsC,kBAAA;AA4KvD;;AA1KA;EAAmB,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,cAAA;EAAgB,uBAAA;EAAuB,iDAAA;EAAmD,oBAAA;EAAsB,6CAAA;EAA+C,iCAAA;EAAmC,kBAAA;EAAmB,gBAAA;EAAkB,mBAAA;AAyLlT;;AAxLA;EAAkB,aAAA;EAAe,sEAAA;EAAuE,WAAA;EAAY,mBAAA;AA+LpH;;AA9LA;EAAgB,aAAA;EAAe,YAAA;AAmM/B;;AAlMA;EAA8B,YAAA;EAAc,0BAAA;EAA4B,6BAAA;AAwMxE;;AAvMA;EAAiB,aAAA;EAAe,aAAA;EAAe,gBAAA;EAAkB,mBAAA;EAAqB,4CAAA;EAA8C,oEAAA;EAAsE,sCAAA;EAAwC,WAAA;AAkNlP;;AAjNA;EAAuB,2CAAA;AAqNvB;;AApNA;EAAgB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAY,mBAAA;AA4NhG;;AA3NA;EAAgB,YAAA;EAAc,gBAAA;AAgO9B;;AA/NA;EAA+B,cAAA;EAAgB,YAAA;AAoO/C;;AAnOA;EAAgB,mBAAA;EAAqB,kBAAA;EAAmB,mBAAA;EAAoB,qDAAA;EAAuD,oCAAA;EAAsC,kBAAA;AA4OzK;;AA3OA;EAAuB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAY,gBAAA;EAAkB,uBAAA;EAAuB,iDAAA;EAAmD,uCAAA;EAAyC,4CAAA;EAA8C,wCAAA;EAA0C,kBAAA;AAwPpS;;AAvPA;EAA2B,iCAAA;EAAmC,kBAAA;AA4P9D;;AA3PA;EAAe,uBAAA;EAAuB,SAAA;EAAW,uBAAA;EAAyB,iCAAA;EAAmC,iBAAA;EAAkB,gBAAA;EAAkB,0BAAA;EAA4B,eAAA;AAsQ7K;;AArQA;EAAoC,iBAAA;AAyQpC;;AAvQA;EAA6B,aAAA;EAAe,iBAAA;EAAmB,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,YAAA;EAAa,eAAA;EAAiB,uCAAA;EAAyC,kBAAA;AAmR5M;;AAlRA;EAAqC,uCAAA;EAAyC,iBAAA;AAuR9E;;AAtRA;EAAmC,SAAA;EAAW,sCAAA;EAAwC,eAAA;EAAiB,gBAAA;AA6RvG;;AA5RA;EAAiC,SAAA;EAAW,wCAAA;EAA0C,kBAAA;AAkStF;;AAjSA;EAAmB,gCAAA;AAqSnB;;AApSA;EAAmB,qBAAA;EAAuB,aAAA;EAAe,cAAA;EAAgB,2CAAA;EAA6C,4CAAA;EAA8C,kBAAA;EAAoB,4CAAA;AA8SxL;;AA7SA;EAAyB,WAAA;EAAa,YAAA;EAAc,iBAAA;AAmTpD;;AAlTA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAa,gBAAA;EAAkB,wCAAA;EAA0C,kBAAA;AA2T/H;;AA1TA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAY,gBAAA;EAAiB,sBAAA;EAAsB,2CAAA;EAA6C,uCAAA;EAAyC,wCAAA;EAA0C,kBAAA;AAsUvO;;AArUA;EAAuB,SAAA;EAAW,uBAAA;EAAyB,iCAAA;EAAmC,gBAAA;EAAkB,0BAAA;AA6UhH;;AA3UA;EAAgB,eAAA;AA+UhB;;AA9UA;EAAkB,kBAAA;EAAoB,eAAA;EAAiB,iDAAA;EAAmD,uCAAA;AAqV1G;;AApVA;EAA0B,qBAAA;AAwV1B;;AAvVA;EAA6B,aAAA;EAAe,mBAAA;EAAqB,YAAA;EAAa,SAAA;EAAW,kBAAA;EAAmB,gBAAA;AAgW5G;;AA/VA;EAAiC,iCAAA;AAmWjC;;AAlWA;EAAgB,oBAAA;EAAsB,kBAAA;EAAoB,eAAA;EAAiB,mBAAA;EAAqB,kBAAA;EAAmB,oBAAA;EAAsB,6CAAA;EAA+C,iCAAA;EAAmC,kBAAA;AA8W3N;;AA7WA;EAAkB,aAAA;EAAe,gDAAA;EAAkD,kBAAA;EAAmB,SAAA;AAoXtG;;AAnXA;EAAwB,YAAA;AAuXxB;;AAtXA;EAAqB,sBAAA;EAAuB,oCAAA;EAAsC,kBAAA;EAAmB,gBAAA;AA6XrG;;AA5XA;EAAqB,SAAA;EAAW,uBAAA;EAAyB,sCAAA;EAAwC,kBAAA;EAAmB,qBAAA;AAoYpH;;AAnYA;EAA8B,2DAAA;EAA6D,kBAAA;AAwY3F;;AAvYA;EAAoB,aAAA;EAAe,eAAA;EAAiB,WAAA;AA6YpD;;AA5YA;EAAe,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,eAAA;EAAiB,sBAAA;EAAsB,iDAAA;EAAmD,oBAAA;EAAsB,4CAAA;EAA8C,wCAAA;EAA0C,kBAAA;AAyZ/Q;;AAxZA;EAAiB,iCAAA;AA4ZjB;;AA3ZA;EAAoB,uBAAA;AA+ZpB;;AA9ZA;EAAgB,gBAAA;AAkahB;;AAjaA;EAAe,kBAAA;EAAoB,iBAAA;EAAmB,qDAAA;AAuatD;;AAtaA;EAAoB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAY,mBAAA;EAAqB,oBAAA;EAAqB,uCAAA;EAAyC,kBAAA;EAAmB,gBAAA;AAkb1M;;AAjbA;EAA4B,wCAAA;EAA0C,sCAAA;AAsbtE;;AArbA;EAAiD,6CAAA;EAA+C,2CAAA;AA0bhG;;AAzbA;EAAsC,uCAAA;EAAyC,wCAAA;AA8b/E;;AA7bA;EAAiB,gBAAA;AAicjB;;AAhcA;EAAkB,WAAA;EAAa,YAAA;EAAc,2CAAA;EAAyC,sBAAA;EAAwB,kBAAA;EAAoB,4CAAA;AAyclI;;AAvcA;EAA0B;IAAK,yBAAA;EA4c7B;AACF;AA5cA;EACE;IAAkB,8BAAA;IAAgC,YAAA;IAAa,sBAAA;EAid/D;EAhdA;IAAa,sBAAA;IAAwB,uBAAA;IAAyB,YAAA;IAAa,WAAA;IAAa,kBAAA;EAudxF;EAtdA;IAAc,iBAAA;IAAkB,mBAAA;EA0dhC;EAzdA;IAAkB,aAAA;IAAc,gBAAA;EA6dhC;EA5dA;IAAkB,qCAAA;EA+dlB;EA9dA;IAAgB,mBAAA;EAiehB;EAheA;IAAkB,qCAAA;EAmelB;AACF;AAleA;EACE;IAAuB,2BAAA;EAqevB;EApeA;IAAe,sBAAA;EAuef;EAteA;IAAc,oBAAA;EAyed;EAxeA;IAAgB,aAAA;IAAe,cAAA;EA4e/B;EA3eA;IAAiB,WAAA;EA8ejB;EA7eA;IAAsB,aAAA;EAgftB;EA/eA;IAAmB,sBAAA;IAAsB,iBAAA;EAmfzC;EAlfA;IAAgB,uBAAA;IAAyB,sBAAA;EAsfzC;EArfA;IAA+B,oBAAA;IAAsB,eAAA;EAyfrD;EAxfA;IAAe,oBAAA;IAAsB,eAAA;EA4frC;EA3fA;IAAoB,cAAA;EA8fpB;AACF;AA7fA;EACE;IAAyB,qCAAA;IAAsC,uCAAA;IAAyC,sCAAA;IAAuC,gCAAA;EAmgB/I;AACF;AAjgBA,+CAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;EACA,mBAAA;AAmgBF;;AAhgBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,2CAAA;EACA,uCAAA;EACA,mCAAA;EACA,eAAA;EACA,uFAAA;AAmgBF;;AAhgBA;EACE,wCAAA;EACA,6CAAA;EACA,6CAAA;AAmgBF;;AAhgBA;EACE,cAAA;EACA,mBAAA;EACA,wCAAA;AAmgBF;;AAhgBA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uCAAA;EACA,6CAAA;EACA,iCAAA;EACA,eAAA;AAmgBF;;AAhgBA;EAAoB,aAAA;EAAe,WAAA;EAAY,YAAA;AAsgB/C;;AArgBA;EAA2B,sCAAA;EAAwC,kBAAA;AA0gBnE;;AAzgBA;EAA0B,wCAAA;EAA0C,kBAAA;EAAmB,gBAAA;AA+gBvF;;AA7gBA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,wBAAA;EACA,iDAAA;EACA,uDAAA;EACA,uCAAA;EACA,4CAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AAghBF;;AA9gBA;EAA+B,kBAAA;EAAmB,iCAAA;EAAmC,eAAA;AAohBrF;;AAnhBA;EAAkC,sCAAA;AAuhBlC;;AArhBA;EACE,kBAAA;EACA,aAAA;EACA,iDAAA;EACA,uCAAA;EACA,2CAAA;AAwhBF;;AAthBA;EAA0B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,YAAA;EAAa,qBAAA;AA8hB3G;;AA7hBA;EAA6B,SAAA;EAAW,iBAAA;EAAkB,gBAAA;AAmiB1D;;AAliBA;EAAiC,oCAAA;EAAsC,kBAAA;AAuiBvE;;AAtiBA;EAAqB,aAAA;EAAe,+CAAA;EAAiD,mBAAA;EAAqB,WAAA;EAAY,kBAAA;EAAmB,qDAAA;AA+iBzI;;AA9iBA;EAA0B,aAAA;EAAe,uBAAA;EAAyB,WAAA;EAAY,YAAA;AAqjB9E;;AApjBA;EAA8B,kBAAA;EAAmB,iCAAA;AAyjBjD;;AAxjBA;EAAgC,aAAA;EAAe,WAAA;EAAY,YAAA;AA8jB3D;;AA7jBA;EAAiC,uBAAA;EAAyB,sCAAA;EAAwC,kBAAA;AAmkBlG;;AAlkBA;EAAgC,uBAAA;EAAyB,oCAAA;EAAsC,2DAAA;EAA6D,kBAAA;AAykB5J;;AAxkBA;EAAuB,uBAAA;EAAuB,yCAAA;EAA0C,oBAAA;EAAsB,mCAAA;EAAoC,iCAAA;EAAmC,iBAAA;EAAkB,gBAAA;EAAkB,mBAAA;AAmlBzN;;AAllBA;EAA+B,qCAAA;EAAsC,6CAAA;EAA+C,iCAAA;AAwlBpH;;AAvlBA;EAAyB,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,eAAA;EAAiB,YAAA;AA+lBzG;;AA9lBA;EAA8B,oBAAA;EAAsB,mBAAA;EAAqB,YAAA;EAAa,kBAAA;AAqmBtF;;AApmBA;EAAuB,mBAAA;AAwmBvB;;AAvmBA;EAAoC,cAAA;AA2mBpC;;AAzmBA,mBAAA;AACA;EAAqB,kBAAA;AA6mBrB;;AA5mBA;EAAwB,mBAAA;EAAoB,wCAAA;EAA0C,kBAAA;EAAmB,gBAAA;AAmnBzG;;AAlnBA;EAAqB,qBAAA;EAAsB,iCAAA;EAAmC,kBAAA;EAAmB,gBAAA;EAAkB,mBAAA;AA0nBnH;;AAznBA;EAAuB,kBAAA;EAAmB,eAAA;EAAgB,iDAAA;EAAmD,uCAAA;AAgoB7G;;AA/nBA;EAA+B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,YAAA;EAAa,sBAAA;AAuoBhH;;AAtoBA;EAAsC,uBAAA;EAAyB,sCAAA;EAAwC,kBAAA;AA4oBvG;;AA3oBA;EAAoC,oCAAA;EAAsC,kBAAA;EAAmB,mBAAA;AAipB7F;;AAhpBA;EAA8B,yBAAA;EAAyB,wCAAA;EAA0C,kBAAA;EAAmB,gBAAA;AAupBpH;;AAtpBA;EAAqB,oCAAA;EAAsC,iBAAA;AA2pB3D;;AAzpBA,4DAAA;AACA;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iCAAA;EACA,0BAAA;AA4pBF;;AAzpBA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,qBAAA;EACA,mCAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,6CAAA;AA4pBF;;AAzpBA;EAAwB,aAAA;EAAe,uBAAA;EAAyB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;AAiqB3G;;AAhqBA;EAA2B,wBAAA;EAAwB,sCAAA;EAAwC,iBAAA;EAAmB,gBAAA;AAuqB9G;;AAtqBA;EAA0B,SAAA;EAAW,wCAAA;EAA0C,kBAAA;EAAmB,iBAAA;AA6qBlG;;AA5qBA;EAAsB,aAAA;EAAe,cAAA;EAAgB,cAAA;EAAgB,eAAA;EAAiB,mBAAA;EAAqB,2CAAA;EAA6C,uCAAA;EAAyC,mCAAA;EAAqC,wCAAA;AAwrBtO;;AAvrBA;EAA4B,4CAAA;EAA8C,iCAAA;AA4rB1E;;AA3rBA;EAAwB,sBAAA;AA+rBxB;;AA9rBA;EAAe,gBAAA;AAksBf;;AAjsBA;EAAsB,gBAAA;AAqsBtB;;AApsBA;EAAsB,kBAAA;AAwsBtB;;AAvsBA;EAAwB,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,YAAA;EAAa,gBAAA;EAAkB,iBAAA;EAAmB,qDAAA;AAitBzI;;AAhtBA;EAA6B,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,YAAA;EAAa,mBAAA;EAAqB,uCAAA;EAAyC,kBAAA;EAAmB,gBAAA;AA2tB/L;;AA1tBA;EAAqC,wCAAA;EAA0C,sCAAA;AA+tB/E;;AA9tBA;EAA2C,6CAAA;EAA+C,2CAAA;AAmuB1F;;AAjuBA;EACE;IAAoB,qCAAA;EAquBpB;EApuBA;IAAqB,0CAAA;EAuuBrB;EAtuBA;IAAyB,iBAAA;IAAqB,2BAAA;EA0uB9C;AACF;AAxuBA;EACE;IAA0B,qBAAA;IAAuB,UAAA;EA4uBjD;EA3uBA;IAAiB,WAAA;IAAa,gBAAA;IAAkB,oBAAA;IAAqB,4BAAA;EAivBrE;EAhvBA;IAA2B,kBAAA;EAmvB3B;EAlvBA;IAAqB,qCAAA;EAqvBrB;EApvBA;IAAuB,mBAAA;EAuvBvB;EAtvBA;IAAyB,iBAAA;EAyvBzB;EAxvBA;IAAuB,uBAAA;IAAyB,eAAA;EA4vBhD;EA3vBA;IAA+B,uBAAA;IAAyB,sBAAA;IAAwB,YAAA;EAgwBhF;EA/vBA;IAAwB,gBAAA;IAAkB,aAAA;IAAe,sBAAA;IAAuB,eAAA;IAAgB,mCAAA;EAswBhG;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin-top: 1.5rem;\n  margin-left: 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--ca-primary-dark, #0d2863);\n    text-decoration: underline;\n  }\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 3px;\n    border-radius: var(--ca-radius-sm, 6px);\n  }\n}\n\n.breadcrumb-link i {\n  font-size: 1.25rem;\n}\n\n.breadcrumb-separator {\n  color: var(--ca-text-muted, #8c96a8);\n}\n\n.breadcrumb-current {\n  \n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.mapping-wizard-page {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 1.5rem clamp(1rem, 2.5vw, 2rem) 2rem;\n}\n\n.page-header, .page-heading, .panel-heading, .step-footer, .table-footer,\n.review-section-heading, .field-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.page-header { align-items: flex-start; margin-bottom: 1.5rem; }\n.page-heading { justify-content: flex-start; align-items: flex-start; }\n.heading-icon, .panel-heading-icon {\n  display: grid;\n  flex: 0 0 auto;\n  width: 3rem;\n  height: 3rem;\n  place-items: center;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1.35rem;\n}\n.eyebrow, .panel-kicker {\n  margin: 0 0 .25rem;\n  color: var(--ca-primary-light, #2850ad);\n  font-size: .68rem;\n  font-weight: 800;\n  letter-spacing: .12em;\n  text-transform: uppercase;\n}\n.page-header h1 { margin: 0; font-size: clamp(1.35rem, 2vw, 1.8rem); font-weight: 750; letter-spacing: -.035em; }\n.subtitle { max-width: 52rem; margin: .45rem 0 0; color: var(--ca-text-secondary, #4b5870); font-size: .88rem; line-height: 1.55; }\n.cancel-top { flex: 0 0 auto; display: inline-flex; align-items: center; gap: .45rem; border-radius: var(--ca-radius-md, 8px); }\n.page-alert { display: flex; align-items: center; gap: .55rem; }\n\n.wizard-stepper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(.35rem, 1.3vw, 1.2rem);\n  margin: 0 auto 1.4rem;\n  padding: 1.1rem 1.4rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: 0 3px 12px rgba(18, 35, 68, .035);\n}\n.step-item { display: inline-flex; align-items: center; gap: .65rem; min-width: 0; padding: .2rem; border: 0; background: transparent; color: var(--ca-text-muted, #8c96a8); cursor: default; text-align: left; }\n.step-item:disabled { opacity: 1; }\n.step-icon { display: grid; width: 2.35rem; height: 2.35rem; flex: 0 0 2.35rem; place-items: center; border: 1px solid var(--ca-border, #dfe4ec); border-radius: 50%; background: var(--ca-bg-secondary, #eef2f8); font-size: 1rem; transition: all .18s ease; }\n.step-label { font-size: .82rem; font-weight: 650; white-space: nowrap; }\n.step-item.active { color: var(--ca-primary, #0e2e80); }\n.step-item.active .step-icon { border-color: var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); color: #fff; box-shadow: 0 0 0 4px rgba(40, 80, 173, .1); }\n.step-item.completed { color: var(--ca-success, #198754); cursor: pointer; }\n.step-item.completed .step-icon { border-color: var(--ca-success, #198754); background: var(--ca-success, #198754); color: #fff; }\n.step-connector { width: clamp(1rem, 4vw, 4rem); height: 2px; flex: 0 1 4rem; background: var(--ca-border, #dfe4ec); }\n.step-connector.completed { background: var(--ca-success, #198754); }\n\n.wizard-card { overflow: hidden; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-lg, 12px); background: var(--ca-surface, #fff); box-shadow: 0 5px 20px rgba(18, 35, 68, .04); }\n.wizard-panel { padding: clamp(1rem, 2.5vw, 1.8rem); }\n.panel-heading { align-items: flex-start; margin-bottom: 1.4rem; }\n.panel-heading h2 { margin: .1rem 0 .3rem; color: var(--ca-text-primary, #172033); font-size: 1.25rem; font-weight: 750; letter-spacing: -.02em; }\n.panel-heading p { max-width: 58rem; margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .85rem; line-height: 1.55; }\n.panel-heading-icon { width: 2.65rem; height: 2.65rem; font-size: 1.2rem; }\n\n.mapping-form { max-width: 850px; }\n.form-field { margin-bottom: 1.3rem; }\n.form-field label { display: block; margin-bottom: .45rem; color: var(--ca-text-primary, #172033); font-size: .85rem; font-weight: 700; }\n.required-mark { color: var(--ca-danger, #dc3545); }\n.form-control, .form-select { min-height: 2.7rem; border-color: var(--ca-input-border, #dfe4ec); border-radius: var(--ca-radius-md, 8px); color: var(--ca-text-primary, #172033); font-size: .88rem; }\n.form-control:focus, .form-select:focus { border-color: var(--ca-input-focus, #2850ad); box-shadow: 0 0 0 .18rem rgba(40, 80, 173, .13); }\n.form-control[readonly] { background: var(--ca-bg-secondary, #eef2f8); color: var(--ca-text-secondary, #4b5870); }\n.description-control { min-height: 8rem; resize: vertical; }\n.field-hint { color: var(--ca-text-muted, #8c96a8); font-size: .75rem; }\n.field-error { color: var(--ca-danger, #dc3545); font-size: .75rem; }\n.field-meta { min-height: 1.25rem; margin-top: .3rem; }\n.required-note { color: var(--ca-text-muted, #8c96a8); font-size: .76rem; }\n\n.selection-count { display: inline-flex; align-items: center; gap: .45rem; flex: 0 0 auto; padding: .5rem .75rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: 999px; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: .78rem; font-weight: 700; white-space: nowrap; }\n.search-toolbar { display: grid; grid-template-columns: minmax(12rem, 1.5fr) minmax(11rem, .85fr) auto; gap: .7rem; margin-bottom: 1rem; }\n.search-field { display: flex; min-width: 0; }\n.search-field .form-control { min-width: 0; border-top-right-radius: 0; border-bottom-right-radius: 0; }\n.search-submit { display: grid; width: 2.7rem; flex: 0 0 2.7rem; place-items: center; border: 1px solid var(--ca-primary, #0e2e80); border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0; background: var(--ca-primary, #0e2e80); color: #fff; }\n.search-submit:hover { background: var(--ca-primary-dark, #0d2863); }\n.clear-button { display: inline-flex; align-items: center; justify-content: center; gap: .4rem; white-space: nowrap; }\n.table-region { min-width: 0; overflow-x: auto; }\n.table-region app-main-table { display: block; min-width: 0; }\n.table-footer { align-items: center; margin-top: .9rem; padding-top: .8rem; border-top: 1px solid var(--ca-border-light, #e9edf3); color: var(--ca-text-muted, #8c96a8); font-size: .76rem; }\n.selected-zone-strip { display: flex; align-items: center; gap: .6rem; margin: 0 0 1rem; padding: .75rem .9rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-md, 8px); background: var(--ca-surface-hover, #f8faff); color: var(--ca-text-secondary, #4b5870); font-size: .82rem; }\n.selected-zone-strip > i { color: var(--ca-primary, #0e2e80); font-size: 1.05rem; }\n.text-button { padding: .25rem .2rem; border: 0; background: transparent; color: var(--ca-primary, #0e2e80); font-size: .8rem; font-weight: 700; text-decoration: underline; cursor: pointer; }\n.selected-zone-strip .text-button { margin-left: auto; }\n\n.state-panel, .empty-state { display: flex; min-height: 12rem; flex-direction: column; align-items: center; justify-content: center; gap: .55rem; padding: 1.5rem; color: var(--ca-text-tertiary, #6f7b91); text-align: center; }\n.state-panel > i, .empty-state > i { color: var(--ca-primary-light, #2850ad); font-size: 1.8rem; }\n.state-panel h3, .empty-state h3 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 1rem; font-weight: 700; }\n.state-panel p, .empty-state p { margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .84rem; }\n.error-state > i { color: var(--ca-danger, #dc3545); }\n.loading-spinner { display: inline-block; width: 1.8rem; height: 1.8rem; border: 3px solid var(--ca-border, #dfe4ec); border-top-color: var(--ca-primary, #0e2e80); border-radius: 50%; animation: mapping-spin .8s linear infinite; }\n.loading-spinner.small { width: 1rem; height: 1rem; border-width: 2px; }\n.inline-loading { display: flex; align-items: center; gap: .55rem; min-height: 3rem; color: var(--ca-text-secondary, #4b5870); font-size: .82rem; }\n.inline-error { display: flex; align-items: center; gap: .5rem; margin: .5rem 0; padding: .7rem .8rem; border: 1px solid var(--ca-danger, #dc3545); border-radius: var(--ca-radius-md, 8px); background: var(--ca-danger-bg, #fdecef); font-size: .82rem; }\n.inline-error button { border: 0; background: transparent; color: var(--ca-primary, #0e2e80); font-weight: 700; text-decoration: underline; }\n\n.review-panel { max-width: none; }\n.review-section { margin-top: 1.1rem; padding: 1.1rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-md, 8px); }\n.review-section-heading { margin-bottom: .8rem; }\n.review-section-heading h3 { display: flex; align-items: center; gap: .55rem; margin: 0; font-size: .94rem; font-weight: 750; }\n.review-section-heading h3 > i { color: var(--ca-primary, #0e2e80); }\n.review-count { display: inline-grid; min-width: 1.45rem; height: 1.45rem; place-items: center; padding: 0 .35rem; border-radius: 999px; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: .72rem; }\n.review-details { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: .9rem 1.5rem; margin: 0; }\n.review-details > div { min-width: 0; }\n.review-details dt { margin-bottom: .25rem; color: var(--ca-text-muted, #8c96a8); font-size: .73rem; font-weight: 700; }\n.review-details dd { margin: 0; overflow-wrap: anywhere; color: var(--ca-text-primary, #172033); font-size: .87rem; white-space: pre-wrap; }\n.review-details .identifier { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: .78rem; }\n.review-chip-list { display: flex; flex-wrap: wrap; gap: .5rem; }\n.review-chip { display: inline-flex; align-items: center; gap: .45rem; max-width: 100%; padding: .5rem .7rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: 999px; background: var(--ca-surface-hover, #f8faff); color: var(--ca-text-secondary, #4b5870); font-size: .78rem; }\n.review-chip i { color: var(--ca-primary, #0e2e80); }\n.review-chip span { overflow-wrap: anywhere; }\n.submit-alert { margin-top: 1rem; }\n.step-footer { margin-top: 1.6rem; padding-top: 1rem; border-top: 1px solid var(--ca-border-light, #e9edf3); }\n.step-footer .btn { display: inline-flex; align-items: center; justify-content: center; gap: .5rem; min-height: 2.55rem; padding: .6rem 1rem; border-radius: var(--ca-radius-md, 8px); font-size: .83rem; font-weight: 650; }\n.step-footer .btn-primary { border-color: var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); }\n.step-footer .btn-primary:hover:not(:disabled) { border-color: var(--ca-primary-dark, #0d2863); background: var(--ca-primary-dark, #0d2863); }\n.step-footer .btn-outline-secondary { border-color: var(--ca-border, #dfe4ec); color: var(--ca-text-secondary, #4b5870); }\n.finish-button { min-width: 10rem; }\n.button-spinner { width: 1rem; height: 1rem; border: 2px solid rgba(255,255,255,.45); border-top-color: #fff; border-radius: 50%; animation: mapping-spin .7s linear infinite; }\n\n@keyframes mapping-spin { to { transform: rotate(360deg); } }\n@media (max-width: 850px) {\n  .wizard-stepper { justify-content: space-between; gap: .25rem; padding-inline: .7rem; }\n  .step-item { flex-direction: column; justify-content: center; gap: .35rem; flex: 1 1 0; text-align: center; }\n  .step-label { font-size: .7rem; white-space: normal; }\n  .step-connector { width: .7rem; flex: 0 0 .7rem; }\n  .search-toolbar { grid-template-columns: minmax(0, 1fr); }\n  .clear-button { justify-self: start; }\n  .review-details { grid-template-columns: minmax(0, 1fr); }\n}\n@media (max-width: 520px) {\n  .mapping-wizard-page { padding: 1rem .7rem 1.5rem; }\n  .page-header { flex-direction: column; }\n  .cancel-top { align-self: flex-end; }\n  .heading-icon { width: 2.5rem; height: 2.5rem; }\n  .panel-heading { gap: .6rem; }\n  .panel-heading-icon { display: none; }\n  .selection-count { padding: .4rem .5rem; font-size: .7rem; }\n  .table-footer { align-items: flex-start; flex-direction: column; }\n  .table-footer app-pagination { align-self: flex-end; max-width: 100%; }\n  .step-footer { align-items: stretch; flex-wrap: wrap; }\n  .step-footer .btn { flex: 1 1 auto; }\n}\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; transition-duration: .01ms !important; scroll-behavior: auto !important; }\n}\n\n/* Optional security-zone association choices */\n.zone-choice-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: .85rem;\n  margin-bottom: 1rem;\n}\n\n.zone-choice-card {\n  display: flex;\n  align-items: flex-start;\n  gap: .8rem;\n  min-width: 0;\n  padding: 1rem;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface, #fff);\n  cursor: pointer;\n  transition: border-color .18s ease, background-color .18s ease, box-shadow .18s ease;\n}\n\n.zone-choice-card.selected {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-surface-active, #eef3ff);\n  box-shadow: 0 0 0 2px rgba(40, 80, 173, .08);\n}\n\n.zone-choice-card input {\n  flex: 0 0 auto;\n  margin-top: .28rem;\n  accent-color: var(--ca-primary, #0e2e80);\n}\n\n.zone-choice-icon {\n  display: grid;\n  flex: 0 0 2.25rem;\n  width: 2.25rem;\n  height: 2.25rem;\n  place-items: center;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 1rem;\n}\n\n.zone-choice-copy { display: grid; gap: .3rem; min-width: 0; }\n.zone-choice-copy strong { color: var(--ca-text-primary, #172033); font-size: .86rem; }\n.zone-choice-copy small { color: var(--ca-text-secondary, #4b5870); font-size: .77rem; line-height: 1.5; }\n\n.zone-selection-guidance {\n  display: flex;\n  align-items: flex-start;\n  gap: .65rem;\n  margin: .2rem 0 1.1rem;\n  padding: .85rem .95rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-left: 3px solid var(--ca-primary-light, #2850ad);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-surface-hover, #f8faff);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: .8rem;\n  line-height: 1.55;\n}\n.zone-selection-guidance > i { margin-top: .1rem; color: var(--ca-primary, #0e2e80); font-size: 1rem; }\n.zone-selection-guidance strong { color: var(--ca-text-primary, #172033); }\n\n.selected-zones-panel {\n  margin-top: 1.1rem;\n  padding: 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-bg-secondary, #f8faff);\n}\n.selected-zones-heading { display: flex; align-items: center; justify-content: space-between; gap: .75rem; margin-bottom: .7rem; }\n.selected-zones-heading h3 { margin: 0; font-size: .9rem; font-weight: 750; }\n.selected-zones-heading > span { color: var(--ca-text-muted, #8c96a8); font-size: .75rem; }\n.selected-zone-row { display: grid; grid-template-columns: minmax(0, 1fr) auto auto; align-items: center; gap: .8rem; padding: .75rem 0; border-top: 1px solid var(--ca-border-light, #e9edf3); }\n.selected-zone-identity { display: flex; align-items: flex-start; gap: .6rem; min-width: 0; }\n.selected-zone-identity > i { margin-top: .1rem; color: var(--ca-primary, #0e2e80); }\n.selected-zone-identity > div { display: grid; gap: .2rem; min-width: 0; }\n.selected-zone-identity strong { overflow-wrap: anywhere; color: var(--ca-text-primary, #172033); font-size: .82rem; }\n.selected-zone-identity small { overflow-wrap: anywhere; color: var(--ca-text-muted, #8c96a8); font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: .68rem; }\n.zone-coverage-badge { padding: .3rem .55rem; border: 1px solid rgba(25, 135, 84, .18); border-radius: 999px; background: rgba(25, 135, 84, .08); color: var(--ca-success, #198754); font-size: .7rem; font-weight: 700; white-space: nowrap; }\n.zone-coverage-badge.partial { border-color: rgba(40, 80, 173, .18); background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); }\n.selected-zone-actions { display: flex; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: .45rem; }\n.selected-zone-actions .btn { display: inline-flex; align-items: center; gap: .35rem; font-size: .72rem; }\n.unzoned-assets-note { align-items: center; }\n.unzoned-assets-note .text-button { flex: 0 0 auto; }\n\n/* Review summary */\n.review-subsection { margin-top: .9rem; }\n.review-subsection h4 { margin: 0 0 .55rem; color: var(--ca-text-secondary, #4b5870); font-size: .78rem; font-weight: 750; }\n.review-chip small { padding-left: .25rem; color: var(--ca-primary, #0e2e80); font-size: .67rem; font-weight: 700; white-space: nowrap; }\n.review-partial-zone { margin-top: .6rem; padding: .8rem; border: 1px solid var(--ca-border-light, #e9edf3); border-radius: var(--ca-radius-sm, 6px); }\n.review-partial-zone-heading { display: flex; align-items: center; justify-content: space-between; gap: .75rem; margin-bottom: .65rem; }\n.review-partial-zone-heading strong { overflow-wrap: anywhere; color: var(--ca-text-primary, #172033); font-size: .82rem; }\n.review-partial-zone-heading span { color: var(--ca-text-muted, #8c96a8); font-size: .72rem; white-space: nowrap; }\n.review-section-description { margin: -.2rem 0 .75rem; color: var(--ca-text-secondary, #4b5870); font-size: .78rem; line-height: 1.5; }\n.review-empty-note { color: var(--ca-text-muted, #8c96a8); font-size: .8rem; }\n\n/* Checkbox table popup for partial security-zone coverage */\n.mapping-modal-backdrop {\n  position: fixed;\n  z-index: 1200;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(9, 18, 38, .56);\n  backdrop-filter: blur(2px);\n}\n\n.mapping-modal {\n  display: flex;\n  flex-direction: column;\n  width: min(100%, 1050px);\n  max-height: min(92vh, 950px);\n  overflow: hidden auto;\n  padding: clamp(1rem, 2.4vw, 1.6rem);\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: 0 24px 80px rgba(9, 18, 38, .25);\n}\n\n.mapping-modal-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; margin-bottom: 1rem; }\n.mapping-modal-header h2 { margin: .1rem 0 .35rem; color: var(--ca-text-primary, #172033); font-size: 1.2rem; font-weight: 750; }\n.mapping-modal-header p { margin: 0; color: var(--ca-text-secondary, #4b5870); font-size: .82rem; line-height: 1.55; }\n.modal-close-button { display: grid; flex: 0 0 auto; width: 2.25rem; height: 2.25rem; place-items: center; border: 1px solid var(--ca-border, #dfe4ec); border-radius: var(--ca-radius-sm, 6px); background: var(--ca-surface, #fff); color: var(--ca-text-secondary, #4b5870); }\n.modal-close-button:hover { background: var(--ca-surface-hover, #f8faff); color: var(--ca-primary, #0e2e80); }\n.modal-search-toolbar { margin-bottom: .75rem; }\n.modal-state { min-height: 8rem; }\n.modal-table-region { min-height: 5rem; }\n.modal-table-footer { margin-top: .6rem; }\n.mapping-modal-footer { display: flex; align-items: center; justify-content: flex-end; gap: .65rem; margin-top: 1rem; padding-top: 1rem; border-top: 1px solid var(--ca-border-light, #e9edf3); }\n.mapping-modal-footer .btn { display: inline-flex; align-items: center; justify-content: center; gap: .45rem; min-height: 2.55rem; border-radius: var(--ca-radius-md, 8px); font-size: .82rem; font-weight: 650; }\n.mapping-modal-footer .btn-primary { border-color: var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); }\n.mapping-modal-footer .btn-primary:hover { border-color: var(--ca-primary-dark, #0d2863); background: var(--ca-primary-dark, #0d2863); }\n\n@media (max-width: 850px) {\n  .zone-choice-grid { grid-template-columns: minmax(0, 1fr); }\n  .selected-zone-row { grid-template-columns: minmax(0, 1fr) auto; }\n  .selected-zone-actions { grid-column: 1 / -1; justify-content: flex-start; }\n}\n\n@media (max-width: 520px) {\n  .mapping-modal-backdrop { align-items: flex-end; padding: 0; }\n  .mapping-modal { width: 100%; max-height: 94vh; padding: 1rem .8rem; border-radius: 14px 14px 0 0; }\n  .mapping-modal-header h2 { font-size: 1.05rem; }\n  .selected-zone-row { grid-template-columns: minmax(0, 1fr); }\n  .zone-coverage-badge { justify-self: start; }\n  .selected-zone-actions { grid-column: auto; }\n  .unzoned-assets-note { align-items: flex-start; flex-wrap: wrap; }\n  .review-partial-zone-heading { align-items: flex-start; flex-direction: column; gap: .25rem; }\n  .mapping-modal-footer { position: sticky; bottom: -1rem; margin-inline: -.8rem; padding: .8rem; background: var(--ca-surface, #fff); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
